import React, { useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Device from '../devices/Device';
import TextField from '@material-ui/core/TextField';
import { useHistory } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme) => ({
  formControl: { margin: theme.spacing(1), minWidth: 120 },
}));

const KitFormAdd = (props) => {
  const initialKit = props.formData || { no: '', description: '', Appareils: [] };
  const [kit, setKit] = useState({ ...initialKit, Appareils: initialKit.Appareils || [] });
  const [dbid, setDbId] = useState(props.dbid);
  const [devices, setDevices] = useState([]);
  const [number, setNumber] = useState(initialKit.no || '');
  const [description, setDescription] = useState(initialKit.description || '');
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    const nextKit = props.formData || { no: '', description: '', Appareils: [] };
    setKit({ ...nextKit, Appareils: nextKit.Appareils || [] });
    setDbId(props.dbid);
    setNumber(nextKit.no || '');
    setDescription(nextKit.description || '');

    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/devices', { method: 'GET' })
      .then((res) => res.json())
      .then((allDevices) => {
        const inKitIds = new Set((nextKit.Appareils || []).map((x) => x._id));
        setDevices(allDevices.filter((device) => !inKitIds.has(device._id)));
      });
  }, [props.formData, props.dbid]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...kit, no: number, description };
    const reqString = props.createMode ? process.env.REACT_APP_PROXY_HOST + '/liste/kits' : process.env.REACT_APP_PROXY_HOST + '/liste/kits/' + dbid;
    const reqMethod = props.createMode ? 'POST' : 'PUT';

    fetch(reqString, {
      method: reqMethod,
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
    }).then(() => {
      history.push({ pathname: '/kits' });
    });
  };

  const handleFunctionChange = (value, index) => {
    const updatedAppareils = [...kit.Appareils];
    updatedAppareils[index] = { ...updatedAppareils[index], fonction: value };
    setKit({ ...kit, Appareils: updatedAppareils });
  };

  const addKitDevice = (device) => {
    if (kit.Appareils.some((x) => x._id === device._id)) {
      return;
    }
    setKit({ ...kit, Appareils: [...kit.Appareils, device] });
    setDevices(devices.filter((x) => x._id !== device._id));
  };

  const removeKitDevice = (device) => {
    setKit({ ...kit, Appareils: kit.Appareils.filter((x) => x._id !== device._id) });
    if (!devices.some((x) => x._id === device._id)) {
      setDevices([...devices, device]);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField id="standard-number" label="Number" type="number" value={number} onChange={(e) => setNumber(e.target.value)} InputLabelProps={{ shrink: true }} />
      <TextField id="standard-helperText" label="Description" value={description} onChange={(e) => setDescription(e.target.value)} helperText="Description du kit" />

      <h2>Dans le kit</h2>
      <List component="nav" aria-label="secondary mailbox folders">
        {(kit.Appareils || []).map((device, i) => (
          <ListItem button key={device._id || i}>
            <ListItemText><Device _id={device._id} /></ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="remove" onClick={() => removeKitDevice(device)}><RemoveIcon /></IconButton>
            </ListItemSecondaryAction>
            <ListItemText>
              <FormControl className={classes.formControl}>
                <InputLabel id={'device-fonction-label-' + i}>Fonction</InputLabel>
                <Select labelId={'device-fonction-label-' + i} value={device.fonction || 1} onChange={(e) => handleFunctionChange(e.target.value, i)}>
                  <MenuItem value={1}>Telecommande</MenuItem>
                  <MenuItem value={100}>Camera</MenuItem>
                </Select>
              </FormControl>
            </ListItemText>
          </ListItem>
        ))}
      </List>

      <h2>Disponible</h2>
      <List component="nav" aria-label="secondary mailbox folders">
        {devices.map((device, i) => (
          <ListItem button key={device._id || i}>
            <ListItemText><Device _id={device._id} /></ListItemText>
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="add" onClick={() => addKitDevice(device)}><AddIcon /></IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>

      <div>
        <button type="submit">Submit</button>
        <button type="button">Cancel</button>
      </div>
    </form>
  );
};

export { KitFormAdd };



// WEBPACK FOOTER //
// src/components/kits/KitForm.js